import { IPageInfo } from './common.interface';
import endpoints from '@constants/configs/endpoints';

export enum SortOrder {
    ASC = 'ASC',
    DESC = 'DESC',
}

export const debounceSearchTime = 300;
export const MAX_AGE_LIMIT = 100;
export const minSearchQueryLength = 3;
export const PAGE_SIZE = 10;
 
export const defaultPageInfo: IPageInfo = {
    currentPage: 1,
    pageSize: PAGE_SIZE,
    sortField: 'id',
    sortOrder: SortOrder.ASC,
};

export enum Gender {
    MALE = 'male',
    FEMALE = 'female',
}

export enum API_STATUS_CODES {
    OK = 200,
    CREATED = 201,
    ACCEPTED = 202,
    NO_CONTENT = 204,

    BAD_REQUEST = 400,
    UNAUTHORIZED = 401,
    FORBIDDEN = 403,
    NOT_FOUND = 404,
    TIMEOUT = 408,
    CONFLICT = 409,
    UNPROCESSABLE_ENTITY = 422,

    INTERNAL_SERVER_ERROR = 500,
    NOT_IMPLEMENTED = 501,
    BAD_GATEWAY = 502,
    SERVICE_UNAVAILABLE = 503,
    GATEWAY_TIMEOUT = 504,
}

export const PLUS_ONE_COUNTRY_CODE = '+1';

export const NON_BREAKING_SPACE = '\u00A0';

/** Display placeholder when a value is missing or empty. */
export const EMPTY_VALUE = '-';

export enum LANGUAGE {
    ENGLISH = 'en',
    SPANISH = 'es'
}

export enum CHAT_LOCALE {
    EN = 'en-US',
    ES = 'es-ES',
}

// Endpoints listed here trigger a hard window.location redirect to the
// generic Fallback page on HTTP 500. Do NOT add an endpoint whose calling
// action already handles errors via SPA navigation, or the two redirects
// will race and produce a brief flash of the action's error page followed
// by a full reload to the Fallback screen.
export const FALLBACK_REDIRECT_ON_SERVER_ERROR_ENDPOINTS = [
    endpoints.MEMBER_ENROLLMENT_LIST_ENROLLEE_DETAILS,
    endpoints.MEMBER_APP_LIST_CONTROLLER,
    endpoints.NOTIFICATIONS,
    endpoints.MEMBER_ACCOUNT_ACTIVITY_INIT_CALL,
    endpoints.MEMBER_APPLICATIONS_HISTORY_BASIC_INFO,
];

// Endpoints listed here return parsed JSON on HTTP 400 so the calling thunk can
// read the error body. All other endpoints
// keep legacy behavior (falsy result on 400 via checkResponse default).
export const PARSE_JSON_ON_BAD_REQUEST_ENDPOINTS = [
    endpoints.MEMBER_APPLICATIONS_HISTORY_BASIC_INFO,
];

/**
 * reCAPTCHA v3 `execute(action)` strings used by the SPA.
 * Must stay in sync with the server’s expected action on token verification.
 */
export const RECAPTCHA_EXECUTE_ACTION = {
    FORGOT_EMAIL: 'forgot_email',
    REFERRAL_ACCESS_CODE: 'referral_access_code',
    SECURITY_QUESTIONS: 'security_questions',
} as const;

export enum API_STATUS {
    SUCCESS = 'success',
    FAILURE = 'failure',
}

export const TOKEN_REFRESH_BUFFER = 30;
